export enum ProposalStatus {
  draft = "draft",
  open = "open",
  denied = "denied",
  cancelled = "cancelled",
  accepted = "accepted",
  archived = "archived",
}
